export default "__VITE_ASSET__c6k6Sui2__"